import { ShipperGuideClient } from 'core/infra/http/ShipperGuideClient'

import { SpotQuoteRepository } from '../infra/SpotQuoteRepository'

export type BookNowSpotQuoteFactoryDependencies = {
  spotQuoteRepository: SpotQuoteRepository
}

export function getBookNowStatusFactory({
  spotQuoteRepository,
}: BookNowSpotQuoteFactoryDependencies) {
  return async function getBookNowStatus(uuid: string, config?: { signal?: AbortSignal }) {
    return await spotQuoteRepository.getBookNowStatus(uuid, config)
  }
}

export function getBookNowStatus(uuid: string, config?: { signal?: AbortSignal }) {
  const httpClient = new ShipperGuideClient()
  const spotQuoteRepository = new SpotQuoteRepository({ httpClient })
  const getBookNowStatus = getBookNowStatusFactory({ spotQuoteRepository })

  return getBookNowStatus(uuid, config)
}
